
<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">HİZMETLER</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Tanımlar</li>
            <li class="breadcrumb-item active">Hizmetler</li>
        </ol>
    </div>
    <div class="data-grid">
        <p-table #dt [value]="logoServices$ | async" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
            [globalFilterFields]="['code','definitioN_','unitsetcode']" [responsive]="true"
            [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="caption">
                <div style="text-align: right">
                    <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
                        (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="code" [width]="'30%'">Hizmet Kodu<p-sortIcon
                            field="code"></p-sortIcon>
                    </th>
                    <th pSortableColumn="definitioN_" [width]="'40%'">Hizmet Adı<p-sortIcon
                            field="definitioN_"></p-sortIcon>
                    </th>
                    <th pSortableColumn="unitsetcode" [width]="'30%'">Birim Seti<p-sortIcon
                            field="unitsetcode"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-services>
                <tr>
                    <td>{{services.code}}</td>
                    <td>{{services.definitioN_}}</td>
                    <td>{{services.unitsetcode}}</td>
                  
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>